<template>
  <v-app class="connector-kyc-layout">
    <v-main>
      <slot />
    </v-main>

    <Snackbar />
  </v-app>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import getBrowserLanguage from '@/plugins/i18n/helpers/getBrowserLanguage'

export default {
  components: {
    Snackbar: () => import('@/components/common/Notification/Snackbar')
  },
  computed: {
    ...mapState({
      userCompany: (state) => state.userCompany.userCompany
    }),
    ...mapGetters({
      userHasCompanyRol: 'auth/userHasCompanyRol'
    })
  },
  mounted () {
    this.setCurrentLanguage()
  },
  methods: {
    setCurrentLanguage () {
      const browserLanguage = getBrowserLanguage()
      const language = this.userCompany?.language && this.userHasCompanyRol ? this.userCompany?.language : browserLanguage
      this.$vuetify.lang.current = language.substring(0, 2)
    }
  }
}
</script>

<style lang="scss" scoped>
.connector-kyc-layout {
  font-family: 'Inter', -apple-system, 'Segoe UI', system-ui, sans-serif;
  background: #FFFFFF;
  color: #1D252F;
}

.connector-kyc-layout::v-deep .v-main {
  background: #FFFFFF;
}
</style>
